import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PreferencesCampusModel } from '../../models/preferences_campus_model';
import { ICampus } from '../../../../../interfaces/scheduler_interfaces';
import { INotificationDelegate } from '../../../../../global/helpers/scheduler_notification_delegate';
import { CampusPreferencesRequestStateCommand } from '../../../../../request_state/commands/campus_preferences_request_state_command';
import { RequestStateQuery } from '../../../../../request_state/queries/request_state_query';

export class CampusLocationController {
  private onlineCampuses: Array<ICampus> = [];
  private offlineCampuses: Array<ICampus> = [];
  private campuses: Array<any> = [];
  private displayError: boolean = false;
  private showOnlineClassesModal: boolean = false;
  private termId: number = 0;
  private campusName: string = '';
  private isFirstTime: () => void;

  constructor(
    private saveTermLocationPreferencesCommand: ICommand,
    private loadTermLocationPreferencesCommand: ICommand,
    private deleteTermLocationPreferencesCommand: ICommand,
    private CampusLocationEnum: any,
    private $q: ng.IQService,
    private $element: ng.IAugmentedJQuery,
    private preferencesSummaryDelegate: any,
    private ngPreferencesCampusModel: PreferencesCampusModel,
    private ngSchedulerNotificationDelegate: INotificationDelegate,
    private ngRequestStateQuery: RequestStateQuery,
    private campusPreferencesRequestStateCommand: CampusPreferencesRequestStateCommand
  ) {}

  isRequiredCampus(campus: ICampus) {
    const isGlobal = _4.get(campus, 'is_global', false);
    if (isGlobal) {
      const requiredCampusName = _4.get(campus, 'name', 'This');
      this.ngSchedulerNotificationDelegate.error(`${requiredCampusName} campus cannot be unselected.`);
    }
    return isGlobal;
  }

  private __onOpenModalTriggerEnded() {
    this.openOnlineClassesModal();
  }

  private __onCloseModalTriggerEnded() {
    this.closeOnlineClassesModal();
  }

  openOnlineClassesModal() {
    this.showOnlineClassesModal = true;
  }

  closeOnlineClassesModal() {
    this.showOnlineClassesModal = false;
  }

  private __onChangeEvent(event: any, campus: ICampus) {
    if (campus.is_global && !event.target.checked) {
      event.target.checked = this.isRequiredCampus(campus);
      return;
    }

    campus._selected = event.target.value;
    this.changeCampus(campus);
    this.isValid();
  }

  changeCampus(campus: any) {
    campus.isUpdated = true;
    const campusIndex = _4.findIndex(this.campuses, { id: campus.id });
    this.campuses[campusIndex] = campus;
  }

  $onInit() {
    this.init();
  }

  isBlended() {
    return _4.isEqual(this.campusName, this.CampusLocationEnum.BLENDED.value.title);
  }

  isValid() {
    const campusesPicked = _4.isEmpty(_4.filter(this.campuses, { _selected: true }));
    this.displayError = campusesPicked;
    return !campusesPicked;
  }

  init() {
    this.loadTermLocationPreferencesCommand(this.termId).then((model: any) => {
      this.campuses = model.campuses;
      this.onlineCampuses = _4.filter(this.campuses, 'is_online', true);
      this.offlineCampuses = _4.sortBy(_4.filter(this.campuses, { is_online: false }), ['rank', 'name']);
      this.isValid();
      this.ngPreferencesCampusModel.write(this.campuses);
      this.preferencesSummaryDelegate.setCampusLocation({ campuses: this.campuses });
      const isFirstTimePreferences = _4.get(model, 'prefs_first_visit', false);
      if (isFirstTimePreferences) {
        this.isFirstTime();
      }
    });
  }

  private __onSaveTriggerEnded() {
    if (!this.isValid()) {
      const errorEl = this.$element[0].querySelector('#location-validation-error');
      return errorEl ? errorEl.scrollIntoView({ behavior: 'smooth', inline: 'start' }) : false;
    }

    this.updateCampuses();
  }

  campusUpdationFinished(data: { campus: ICampus['id']; id?: number }) {
    const campusIndex = this.campuses.findIndex((campus) => campus['id'] === data.campus);
    this.campuses[campusIndex].isUpdated = false;
  }

  updateCampuses() {
    this.campusPreferencesRequestStateCommand(true);
    const updatingCampuses = this.campuses.filter((campus) => {
      if (!campus.isUpdated) {
        return false;
      }
      return true;
    });

    const updateCampusEntries = updatingCampuses.map((campus) => {
      const campusID = campus.id;
      return campus._selected
        ? this.saveTermLocationPreferencesCommand(this.termId, campus.id).then(this.campusUpdationFinished.bind(this))
        : this.deleteTermLocationPreferencesCommand(this.termId, campus.id).then(() =>
            this.campusUpdationFinished({
              campus: campusID
            })
          );
    });

    this.$q
      .all(updateCampusEntries)
      .then(() => {
        this.ngSchedulerNotificationDelegate.success({
          content: `Your preferences are updated`
        });
      })
      .finally(() => {
        this.ngPreferencesCampusModel.write(this.campuses);
        this.preferencesSummaryDelegate.setCampusLocation({ campuses: this.campuses });
        this.campusPreferencesRequestStateCommand(false);
      });
  }
}
angular.module('capability-ng-scheduler').component('campusLocation', {
  templateUrl:
    'capability-ng-scheduler/src/views/components/preferences/components/campus_location/campus_location.html',
  bindings: {
    termId: '@',
    isFirstTime: '&'
  },
  controller: CampusLocationController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/components/campus_location/campus_location.ts